module.exports = __webpack_public_path__ + "img/Cool.92802ecf.png";